import { useCallback, useEffect, useState } from 'react';
import { isEmpty, isEqual, sortBy } from 'lodash';

import { getFormattedOptions } from '../utils';

export const useAutocompletOptions = ({
  value,
  options,
  groups,
  selectedGroup,
  isPrioritizedSelectedOptions,
}) => {
  const [autocompleteOptions, setAutocompleteOptions] = useState(options);

  const isGrouped = options?.some(option => option.group) || !isEmpty(groups);
  const formattedOptions = getFormattedOptions(options, isGrouped, selectedGroup);

  const getSortedOptions = useCallback(
    valueToSortBy => {
      if (!Array.isArray(valueToSortBy)) return formattedOptions;
      const selectedIds = new Set(valueToSortBy.map(item => item.id));
      return sortBy(formattedOptions, option => !selectedIds.has(option.id));
    },
    [formattedOptions.length]
  );

  const handleAutocompleOptionsUpdate = () => {
    if (!isPrioritizedSelectedOptions) return;
    setAutocompleteOptions(getSortedOptions(value));
  };

  useEffect(() => {
    if (isPrioritizedSelectedOptions) {
      setAutocompleteOptions(getSortedOptions(value));
      return;
    }
    if (!isEqual(formattedOptions, autocompleteOptions)) {
      setAutocompleteOptions(formattedOptions);
    }
  }, [formattedOptions]);

  return { autocompleteOptions, handleAutocompleOptionsUpdate, isGrouped };
};
